<template>
  <v-btn
    :class="`btn-label ${type}`"
    :disabled="isDisabled"
    :depressed="depressed"
    :block="block"
    :width="width"
    @click="$emit('click', arguments)"
    :outlined="outlined"
    :href="href"
    :target="href ? '_blank' : null"
  >
    <v-icon v-if="actionIcon">{{ actionIcon }}</v-icon>
    <!-- Default slot -->
    <slot></slot>
    <div v-if="badge" class="numberCircle icon-far-right">
      <div class="badgeNum">{{ badge }}</div>
    </div>
  </v-btn>
</template>

<script>
// @group Common
// Styled ActionButton component

export default {
  name: 'ActionButton',
  props: {
    // Designates the component as anchor
    href: {
      type: String,
      default: null
    },
    // Icon to display (left)
    actionIcon: {
      // Example: `'$sl-delete'` etc.
      type: String
    },
    // width of the button
    width: {
      // Example: `200px` etc.
      type: String
    },
    // The type of the ActionButton
    type: {
      //--TODO add secondary css
      // `'action'` / `'destructive'` / `'secondary'`
      type: String,
      // The default value is: `action`
      default: 'action'
    },
    // Should button be depressed style
    depressed: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    // Should we display a number in a badge
    // Should button be block style
    block: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Should we display a number in a badge
    badge: {
      // Non-zero # to display in badge
      type: Number,
      // The default value is: 0
      default: 0
    },
    outlined: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
</style>